// NOTE This file is auto-generated by generated-site-data.mjs

export default {
  bash: "Shell",
  conf: "Config file",
  dockerfile: "Dockerfile",
  elixir: "Elixir",
  go: "Go",
  graphql: "GraphQL",
  java: "Java",
  javascript: "JavaScript",
  json: "JSON",
  js: "JavaScript",
  nodejs: "Nodejs",
  php: "PHP",
  python: "Python",
  rb: "Ruby",
  ruby: "Ruby",
  sh: "Shell",
  shell: "Shell",
  sql: "SQL",
  toml: "TOML",
  yaml: "YAML",
  yml: "YAML",
};
